export const BAIT_SCRIPT_URL =
  "https://imasdk.googleapis.com/js/sdkloader/ima3.js";
